<div id="pendingReport" style="margin-top: 3rem;">
    <app-header title=""></app-header>
    <app-pending></app-pending>
</div>
<div id="pendingReportStyles" #container></div>